import api from '../lib/api';

export const CREATE_TARGET = 'CREATE_TARGET';
export const FETCH_MARKET_TARGETS = 'FETCH_MARKET_TARGETS';
export const UPDATE_TARGET = 'UPDATE_TARGET';
export const DELETE_TARGET = 'DELETE_TARGET';
export const TARGETS_LOADING = 'TARGETS_LOADING';

function fetchTargetDeployments(marketId) {
  return (dispatch) => {
    dispatch({ type: TARGETS_LOADING, payload: true });
    api.getTargetDeployments(marketId)
      .then((data) => {
        dispatch({ type: FETCH_MARKET_TARGETS, payload: data });
        dispatch({ type: TARGETS_LOADING, payload: false });
        return data;
      });
  };
}

function createTargetDeployment(args) {
  return (dispatch) => api.createTargetDeployment(args)
    .then((data) => {
      dispatch({ type: CREATE_TARGET, payload: data });
      return data;
    });
}

function updateTargetDeployment(targetDeploymentId, target, effectiveOn) {
  return (dispatch) => api.updateTargetDeployment(targetDeploymentId, target, effectiveOn)
    .then((data) => {
      dispatch({ type: UPDATE_TARGET, payload: data });
      return data;
    });
}

function deleteTargetDeployment(targetDeploymentId) {
  return (dispatch) => api.deleteTargetDeployment(targetDeploymentId)
    .then((data) => {
      dispatch({ type: DELETE_TARGET, payload: data });
      return data;
    });
}

export default {
  fetchTargetDeployments,
  createTargetDeployment,
  updateTargetDeployment,
  deleteTargetDeployment,
};
